import client from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const PREFIX = 'clients:'

const saveClient = async clientData => {
  const headers = { headers: getAuthHeaders() }
  const response = clientData?.id
    ? await client.patch(`/save/${clientData.id}`, clientData, headers)
    : await client.post('/create', clientData, headers)

  cacheClear(PREFIX)
  window.dispatchEvent(new Event('clientListUpdate'))
  return response
}

export default saveClient
